import React, { useEffect } from 'react';
import { Button, Form, Modal, Schema, SelectPicker } from 'rsuite';
import { CurrencyField, Field } from '../../../../../helpers/rsuite/Form';
import { disableInput } from '../../../../../helpers/styles/Inputs';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

const body0 = {
    width: '540px',
    padding: '0 4px'
};

const required = 'Este campo es requerido.';
const msgNumber = 'Por favor, ingrese un número valido.';
const msgString = 'Por favor, ingrese una opción.';
const { NumberType, StringType } = Schema.Types;

const BaseInstallmentsStep = ({
    context,
    selectedValue,
    setSelectedValue,
    amountTarget,
    setAmountTarget,
    idsPlan,
    installmentAllowed,
    handleAmountChange,
    showFeeValues = true,
    extraContent = null,
    isLoading = false,
    disabledNext = false,
}) => {
    const model = Schema.Model({
        amount: NumberType(msgNumber)
            .addRule((value) => value > 0, 'El monto ingresado no es válido')
            .addRule(
                (value) =>
                    value >= context?.amountLimit?.amountMinByPerson &&
                    value >= context?.amountLimit?.amountMinOfInstallments,
                'El monto seleccionado no puede ser menor al mínimo permitido'
            )
            .addRule(
                (value) =>
                    value <= context?.amountLimit?.amountMaxByPerson &&
                    value <= context?.amountLimit?.amountMaxOfInstallments,
                'El monto seleccionado no puede ser mayor a la oferta'
            )
            .isRequired(required),
        installments: StringType(msgString).isRequired(required),
    });

    const submit = () => {
        if (!context.formRef.current.check()) {
            console.error('Form Error');
            return;
        }
        context.next();
    };

    const back = () => {
        if (context.politicies.length === 1) {
            context.customStep(1, 0);
        }
        else {
            context.back();
        }
    };

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };

    useEffect(() => {
        if (idsPlan.length === 1 && !selectedValue) {
            setSelectedValue(idsPlan[0]);
        }
        // eslint-disable-next-line
    }, [idsPlan, selectedValue]);

    useEffect(() => {
        setAmountTarget('');
        context.setFormInstallments((value) => ({
            ...value,
            amount: '',
            installments: [],
        }));
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Modal.Body className="mb-5 h-100 py-1" style={{ height: '540px', overflow: 'show' }}>
                <div className="row m-0" style={body0} />
                <Form
                    fluid
                    formValue={context.formInstallments}
                    model={model}
                    onChange={context.setFormInstallments}
                    ref={context.formRef}
                    onCheck={context.setFormErrorInstallments}
                >
                    <Field
                        classNameGroup="mb-3"
                        classNameLabel="font-weight-bold"
                        name="maxAmount"
                        label="Monto máximo"
                        value={context.amountLimit?.amountMaxByPerson}
                        accepter={CurrencyField}
                        displayType="text"
                        readOnly
                        style={disableInput}
                    />
                    <Field
                        classNameGroup="mb-3"
                        classNameLabel="font-weight-bold"
                        name="amount"
                        label="Montos"
                        accepter={CurrencyField}
                        error={context.setFormErrorMainUser.amount}
                        onChange={handleAmountChange}
                    />
                    {extraContent}
                    {showFeeValues && (
                        <>
                            <FormControl component="fieldset" style={{ width: '100%' }}>
                                <span style={{ fontWeight: 500 }}>Producto</span>
                                <RadioGroup value={selectedValue} onChange={handleChange} aria-label="" row>
                                    {idsPlan.map((products, index) => (
                                        <FormControlLabel
                                            key={index}
                                            value={String(products)}
                                            control={<Radio />}
                                            label={products}
                                            style={{ width: index % 2 === 0 ? '50%' : '45%' }}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                            <Field
                                classNameGroup="mb-3"
                                classNameLabel="font-weight-bold"
                                name="installments"
                                label="Cuotas"
                                accepter={SelectPicker}
                                data={installmentAllowed}
                                style={{ width: '100%' }}
                                placeholder="Seleccionar"
                            />
                        </>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer className="mt-4">
                <div>
                    <Button
                        appearance="subtle"
                        id="back_btn"
                        disabled={context.isLoading || isLoading}
                        onClick={back}
                    >
                        Atrás
                    </Button>
                    <Button
                        appearance="primary"
                        id="third_forward"
                        disabled={context.isLoading || isLoading || disabledNext}
                        onClick={submit}
                    >
                        Siguiente
                    </Button>
                </div>
            </Modal.Footer>
        </>
    );
};

export default BaseInstallmentsStep;
